import moment from 'moment'

export const ncrQuality = {
  id: '',
  distributedToInternal: '',
  reportedDate: moment().format('YYYY-MM-DD'),
  customerId: '',
  customerName: '',
  address: '',
  pic: '',
  email: '',
  brandId: '',
  brandName: '',
  productId: '',
  productName: '',
  plantId: '',
  plantName: '',
  packagingId: '',
  packagingName: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
  blDate: moment().format('YYYY-MM-DD'),
  dispatchDate : moment().format('YYYY-MM-DD'),
  dischargePort : '',
  countryId: '',
  countryName: '',
  containerNo: '',
  modelOfDeliveryId: '',
  modelOfDeliveryName: '',
  conformanceTypeId: '',
  conformanceTypeName: '',
  complaintMediaId: '',
  complaintMediaName: '',
  enclosedId: '',
  enclosedName: '',
  description: '',
  createdBy: '',
  updatedBy: '',
  ccSalesAttachment: '',
  ccAreaOwnerAttachment: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const ncrCorrectiveExternal = {
  id: '',
  ncrId: '',
  investigationDetail: '',
  corrective: '',
  preventive: '',
}

export const ncrCorrectivePreventiveInternal = {
  id: '',
  ncrId: '',
  rootCauseType: '',
  rootCauseRemark: '',
  actionType: '',
  actionRemark: '',
  workDescription: '',
  evidence: '',
  picId: '',
  picName: '',
  picEmail: '',
  targetDate: moment().format('YYYY-MM-DD'),
}

export const ncrActionTrackerLog = {
  id: '',
  ncrId: '',
  memberId: '',
  type: '',
  item: '',
  remark: '',
  isAnswered: '',
}

export const ncrActionTrackerLogNew = {
  id: '',
  actionNo: '',
  ncrId: '',
  picId: '',
  picEmail: '',
  picName: '',
  actionType: '',
  rootCauseType: '',
  item: '',
  remark: '',
}